export default __webpack_public_path__ + "static/media/guideToInstantCardhelpMobileHighlight.f7ed7080.png";